import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { CardContainerPresentation } from '../CardContainer/CardContainerPresentation.js';
import { CheckboxWrapper } from '../Checkbox/CheckboxWrapper.js';
import { getGridColumnClasses } from '../GridColumn/GridColumnPresentation.js';
import { HeadlinePresentation } from '../Headline/HeadlinePresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { RadioWrapper } from '../Radio/RadioWrapper.js';
import { hostClass } from './CardsCheckboxesItem.styles.js';

// TODO: does not work?
var defaultProps = {
  look: "checkbox",
  centeredLayout: false,
  thumbPosition: "bottom"
};
var CardsCheckboxesItemPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;
  var id = props.id,
    name = props.name,
    children = props.children,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    headline = props.headline,
    headlineAs = props.headlineAs,
    subline = props.subline,
    sublineAs = props.sublineAs,
    overline = props.overline,
    overlineAs = props.overlineAs,
    thumbIcon = props.thumbIcon,
    thumbIconVariant = props.thumbIconVariant,
    thumbTitle = props.thumbTitle,
    thumbPosition = props.thumbPosition,
    centeredLayout = props.centeredLayout,
    disabled = props.disabled,
    look = props.look,
    value = props.value,
    onChange = props.onChange,
    itemsPerRow = props.itemsPerRow,
    gridColumnSize = props.gridColumnSize;
  var anyContentForBottomArea = thumbIcon && thumbPosition === "bottom";
  var size = gridColumnSize || 12 / itemsPerRow;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject, getGridColumnClasses({
      size: size,
      sm: 4,
      xs: 4
    }), true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(CardContainerPresentation, {
    active: true,
    disabled: disabled,
    hasHover: !disabled,
    contentAlignment: centeredLayout ? "center" : undefined,
    topArea: [/*#__PURE__*/React.createElement(ActionPresentation, {
      key: "action",
      onClick: disabled ? function () {
        return null;
      } : function () {
        return onChange(value, name, null);
      },
      name: name
    }, /*#__PURE__*/React.createElement("div", {
      className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-content"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-content__center"), centeredLayout), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-checkbox-space-bottom"), true), _cleanupClassObject2))
    }, look === "checkbox" && /*#__PURE__*/React.createElement(CheckboxWrapper, {
      disabled: disabled,
      name: name,
      value: value
    }), look === "radio" && /*#__PURE__*/React.createElement(RadioWrapper, {
      disabled: disabled,
      name: name,
      value: value,
      onChange: function onChange() {
        return null;
      }
    })), thumbIcon && thumbPosition === "top" && /*#__PURE__*/React.createElement(IconPresentation, {
      icon: thumbIcon,
      size: "large",
      title: thumbTitle,
      variant: thumbIconVariant
    }), /*#__PURE__*/React.createElement(HeadlinePresentation, {
      size: "h4",
      as: headlineAs,
      subline: subline,
      sublineAs: sublineAs,
      overline: overline,
      overlineAs: overlineAs,
      centeredLayout: centeredLayout
    }, headline), children)],
    bottomArea: anyContentForBottomArea && [/*#__PURE__*/React.createElement(React.Fragment, null, thumbIcon && thumbPosition === "bottom" && /*#__PURE__*/React.createElement("div", {
      className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-content"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-content__center"), centeredLayout), _cleanupClassObject3))
    }, /*#__PURE__*/React.createElement(IconPresentation, {
      icon: thumbIcon,
      size: "large",
      title: thumbTitle,
      variant: thumbIconVariant
    })))]
  }));
}, defaultProps);
CardsCheckboxesItemPresentation.displayName = "CardsCheckboxesItemPresentation";

export { CardsCheckboxesItemPresentation, defaultProps };
